export default __webpack_public_path__ + "static/media/twitch.d0cdb5cf.svg";